import { Button, Form, Input, message } from "antd";
import React, { useEffect, useState } from "react";
import { FaUserCircle } from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";
import { getProfile } from "../../services/localStorageServices";
import { post } from "../../apiService";

const AccountDetail = () => {
  const [form] = Form.useForm();
  const { profile } = getProfile();
  const [step, setStep] = useState("otp");
  const [validOTP, setValidOTP] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    form.setFieldsValue({ user_name: profile.user_name });
  }, [profile]);

  const onFinish = async (value) => {
    try {
      setLoading(true);
      switch (step) {
        case "otp":
          const formData = new FormData();
          formData.append("action", "register");
          formData.append("user_email", profile.user_email);
          const resp = await post("/user.php", formData);

          if (resp) {
            setStep("verify");
            message.success("OTP send successfully");
          }
          break;
        case "verify":
          try {
            const formDat = new FormData();
            formDat.append("action", "verify_signup");
            formDat.append("user_email", profile.user_email);
            formDat.append("otp", value.otp);
            const res = await post("/user.php", formDat);

            if (res) {
              setStep("update");
              message.success("OTP Verify");
              setValidOTP("valid");
            }
          } catch (error) {
            console.error(error);
            setValidOTP("notValid");
          }
          break;
        case "update":
          try {
            const formDat = new FormData();
            formDat.append("action", "update_profile");
            formDat.append("user_id", profile.user_id);
            formDat.append("user_name", value.user_name);
            formDat.append("user_password", value.password);
            const res = await post("/user.php", formDat);

            if (res) {
              setStep("otp");
              message.success("Data updated successfully");
              setValidOTP("");
            }
          } catch (error) {
            console.error(error);
            setValidOTP("notValid");
          }
          break;
        default:
          break;
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Form
      layout="vertical"
      className="mb-5 pb-5"
      form={form}
      onFinish={onFinish}
    >
      <div className="row">
        <div className="col-12">
          <Form.Item name="user_name" label="Username">
            <Input prefix={<FaUserCircle />} placeholder="Username" />
          </Form.Item>
        </div>
        <div className="col-md-6">
          <Form.Item
            name="password"
            label="Password"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input.Password
              prefix={<RiLockPasswordFill />}
              placeholder="Password"
            />
          </Form.Item>
        </div>
        <div className="col-md-6">
          <Form.Item
            name="confirm_password"
            label="Confirm Password"
            rules={[
              {
                required: true,
                message: "Please confirm your password!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("The password that you entered do not match!")
                  );
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<RiLockPasswordFill />}
              placeholder="Confirm Password"
            />
          </Form.Item>
        </div>
        <div className="col-md-6">
          {step === "verify" && (
            <Form.Item name="otp" label="Enter OTP">
              <Input.OTP />
            </Form.Item>
          )}
          {validOTP === "notValid" ? (
            <span className="text-danger">Enter Valid OTP</span>
          ) : validOTP === "valid" ? (
            <span className="text-success">OTP Verified</span>
          ) : null}
        </div>
        <div className="col-12 mt-3">
          {step === "otp" ? (
            <Button
              loading={loading}
              htmlType="submit"
              className="bg-dark text-white"
            >
              Send OTP
            </Button>
          ) : step === "verify" ? (
            <Button
              loading={loading}
              htmlType="submit"
              className="bg-warning text-white"
            >
              Verify OTP
            </Button>
          ) : (
            <Button
              loading={loading}
              htmlType="submit"
              className="bg-success text-white"
            >
              Update
            </Button>
          )}
        </div>
      </div>
    </Form>
  );
};

export default AccountDetail;
